export default __webpack_public_path__ + "aedbeb17ebcbda6095d27a2cfda82e76.png";